/* Generated file */

export enum Caracteristique {
	Collectif = "Collectif",
	Individuel = "Individuel",
	NonPrecise = "NonPrecise",
}
